import React from 'react'

interface ISettingsSectionProps {
  id?: string
  title: string
  note?: string
  children: React.ReactNode
}

/** One titled block on a settings page. */
export const SettingsSection = ({ id, title, note, children }: ISettingsSectionProps) => (
  <section id={id} className='settings-section'>
    <h5 className='box-title settings-section-title'>{title}</h5>
    {note && <p className='settings-section-note'>{note}</p>}
    {children}
  </section>
)

interface ISettingsOptionProps {
  type: 'radio' | 'checkbox'
  name?: string
  label: string
  description?: string
  checked: boolean
  disabled?: boolean
  onChange: () => void
  /** The label's language, when it is not the interface language (a language's own name). */
  labelLang?: string
}

/** A radio or checkbox row. The whole row is the label, so a click anywhere changes it once. */
export const SettingsOption = ({
  type,
  name,
  label,
  description,
  checked,
  disabled,
  onChange,
  labelLang,
}: ISettingsOptionProps) => (
  <label className={`settings-option${checked ? ' active' : ''}${disabled ? ' disabled' : ''}`}>
    <input type={type} name={name} checked={checked} disabled={disabled} onChange={onChange} />
    <span className='settings-option-text'>
      <span className='settings-option-label' lang={labelLang}>
        {label}
      </span>
      {description && <span className='settings-option-description'>{description}</span>}
    </span>
  </label>
)
